import { useMemo } from 'react';

import { useFeatureFlag } from '@/modules/featureFlags/useFeatureFlag';
import { MemoPromptMemoPromptType } from '@/types/schema';

import {
  CreatableMemoPromptType,
  MEMO_PROMPT_CARD_ORDER,
} from '../memos.constants';

/** Returns the memo types that the user can create, in display order. */
export function useCreatableMemoPromptTypes(): CreatableMemoPromptType[] {
  const isEstatePlanSummaryEnabled = useFeatureFlag(
    'estate_plan_summary_memo_type_for_choate'
  );

  return useMemo(
    () =>
      MEMO_PROMPT_CARD_ORDER.filter(
        (memoPromptType) =>
          memoPromptType !== MemoPromptMemoPromptType.EstatePlanSummary ||
          isEstatePlanSummaryEnabled
      ),
    [isEstatePlanSummaryEnabled]
  );
}
